import authApi from "api/authApi";
import ModalConfirm from "components/Common/ModalConfirm";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import withRouter from "../../../components/Common/withRouter";
import "./LoginSSOStyled.scss";
import { loginSSO } from "store/thunks";
import { getAccessToken } from "helpers/cookie";
import { ROUTES } from "routes/allRoutes";

function LoginSSO(props: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();
  const params = new URLSearchParams(window.location.search);
  const ssoToken = params.get("token");
  const [isShow, setIsShow] = useState(false);
  //eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const redirectLogin = () => {
    props?.router?.navigate("login");
  };

  const redirectDashboard = () => {
    props?.router?.navigate("dashboard");
  };

  const handleSynchronizeAccount = () => {
    if (ssoToken) {
      dispatch(loginSSO(ssoToken, props.router.navigate, ROUTES.REPORT_MEDIA));
    } else {
      redirectLogin();
    }
  };

  const showModal = () => {
    setIsShow(true);
  };

  const init = async () => {
    try {
      const currentToken = getAccessToken();;
      if (currentToken && ssoToken) {
        const res: any = await authApi.profile();
        if (res?.data && res?.code === 200) {
          showModal();
        } else {
          handleSynchronizeAccount();
        }
      } else {
        handleSynchronizeAccount();
      }
    } catch (error) {
      redirectLogin();
    }
  };

  useEffect(() => {
    init();
    //eslint-disable-next-line
  }, [ssoToken]);

  return (
    <>
      <div className="sso-redirect">
        <span>{t("Navigation is currently being carried out")}</span>
        <svg
          width="50"
          height="16"
          viewBox="0 0 50 16"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginTop: "10px" }}
        >
          <circle cx="6" cy="8" r="2" fill="#333">
            <animate
              attributeName="opacity"
              values="0;1;0"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="16" cy="8" r="2" fill="#333">
            <animate
              attributeName="opacity"
              values="0;1;0"
              begin="0.33s"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="26" cy="8" r="2" fill="#333">
            <animate
              attributeName="opacity"
              values="0;1;0"
              begin="0.66s"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
      <ModalConfirm
        textButtonConfirm={t("Yes")}
        textButtonClose={t("No")}
        classButtonConfirm="btn-primary"
        classIconButtonConfirm={"ri-login-circle-line"}
        header={t("Switch Account")}
        title={t("Login with account from AdsHub. Do you want to switch to your account?")}
        content=""
        isShowIcon={false}
        isOpen={isShow}
        onClose={redirectDashboard}
        onConfirm={handleSynchronizeAccount}
        isLoading={isLoading}
      />
    </>
  );
}

export default withRouter(LoginSSO);
